import { IContactModel } from '@fi-shared/models/common';

export interface ISMSMessageContact extends IContactModel {
    OriginalContactId?: number;
    SentAt?: string; //ISO 8601 date
    SentErrors?: string;
    FullName?: string;
}

export class SmsModel {
    Id: number;
    ParentId: number;
    Text: string;
    SendToPhoneNumberContacts: any[];
    SendToUserContactIds: any[];
    CreatedAt: any;
    SentAt: any;
    SentUserName: string;
    Contacts: ISMSMessageContact[];
    Sender: string;

    constructor(data?) {
        this.InitializeFiSMSModel(data || {});
    }
    InitializeFiSMSModel(data) {
        this.Id = data.Id;
        this.ParentId = data.ParentId;
        this.Text = data.Text;
        this.SendToPhoneNumberContacts = [];
        this.SendToUserContactIds = [];
        this.CreatedAt = data.CreatedAt;
        this.SentAt = data.SentAt;
        this.SentUserName = data.SentUserName || '';
        this.Contacts = data.Contacts || [];
    }
}
